import React from 'react';

import { MetroRequests } from './MetroRequests';
import { withRouteOptions } from 'components/hocs/withRouteOptions';

const MetroRequestsApproval = props => <MetroRequests {...props} approval />;

MetroRequestsApproval.routeOptions = {
    title: 'menu.metroRequestsApproval'
};

export default withRouteOptions(MetroRequestsApproval);
